var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.7 126.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#f7f8de;stroke-miterlimit:10;}.cls-1,.cls-3,.cls-4{stroke-linecap:round;}.cls-1,.cls-3{stroke-width:3px;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-2{stroke-width:4px;}.cls-4{stroke-width:1.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.38,
    y1: 107.48,
    x2: 105.63,
    y2: 20.26
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63.35,
    cy: 63.35,
    r: 61.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.01,
    y1: 38.55,
    x2: 36.24,
    y2: 38.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.01,
    y1: 95.51,
    x2: 36.24,
    y2: 38.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.01,
    y1: 95.51,
    x2: 29.01,
    y2: 95.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.85,45.22c-.38-10.74,3-19.63,9.23-22.27A10.51,10.51,0,0,1,64,22.13",
    transform: "translate(-0.99 -0.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.2,84.24c.83,1.9,2.23,5.07,1.74,5.28s-2.72-2.82-3.86-4.35c0,0-19.68-26.51-19.17-32.07,0-.18.07-.68.37-.78s.6.17.72.25C57.39,59.58,68.2,84.24,68.2,84.24Z",
    transform: "translate(-0.99 -0.49)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.01,
    y1: 38.55,
    x2: 89.77,
    y2: 38.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 97.01,
    y1: 95.51,
    x2: 89.77,
    y2: 38.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.01,
    y1: 95.51,
    x2: 97.01,
    y2: 95.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.15,45.22c.38-10.74-3-19.63-9.22-22.27A10.61,10.61,0,0,0,64,22.13",
    transform: "translate(-0.99 -0.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.41,83.15c.57,2,1.53,5.25,2.07,5.18s.36-3.67.28-5.48c0,0-1.47-31.51-5.58-35.8-.13-.14-.5-.53-.81-.46S67,47,67,47.16C63.91,57.58,71.41,83.15,71.41,83.15Z",
    transform: "translate(-0.99 -0.49)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeout);
export default __webpack_public_path__ + "static/media/takeout.4d7e379de5dedf6540717005b26b7960.svg";
export { ForwardRef as ReactComponent };